import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { IUserType } from '@state/auth/types';

export const fetchBrands = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandsAction => {
  return {
    type: actionsTypes.FETCH_BRANDS,
    query,
    callback
  };
};

export const addBrand = (brand: actionsInterfaces.IBrand, callback: IAsyncActionCallback): actionsInterfaces.IPostBrandAction => {
  return {
    type: actionsTypes.ADD_BRAND,
    brand,
    callback
  };  
};

export const addCustomMetaDataVehicles = (customMetaData: actionsInterfaces.ICustomMetaDataVehicle, callback: IAsyncActionCallback): actionsInterfaces.IPostCustomMetaDataVehicleAction => {
  return {
    type: actionsTypes.ADD_CUSTOM_META_DATA_VEHICLE,
    customMetaData,
    callback
  };  
};

export const setBrands = (brands: actionsInterfaces.IBrand): actionsInterfaces.ISetBrandsAction => {
  return {
    type: actionsTypes.SET_BRAND,
    brands,
  };
};

export const getBrand = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandAction => {
  return {
    type: actionsTypes.GET_BRAND_INFO,
    query,
    callback
  };  
};

export const setBrand = (brand: actionsInterfaces.IBrand): actionsInterfaces.ISetBrandAction => {
  return {
    type: actionsTypes.SET_BRAND_INFO,
    brand,
  };
};

export const addSuccessBrand = (brandResponse: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_BRAND,
    brandResponse,
  };
};

export const addSuccessCustomMetaDataVehicles = (customMetaDataVehicleResponse: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_CUSTOM_META_DATA_VEHICLE,
    customMetaDataVehicleResponse,
  };
};

export const fetchSearchBrands = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH_BRANDS,
    query,
    callback
  };
};

export const setSearchBrands  = (brandSearches: actionsInterfaces.IBrand): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH_BRAND,
    brandSearches,
  };
};

export const updateBrand = (brand: actionsInterfaces.IBrand, location:string , callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateBrandAction => {
  return {
    type: actionsTypes.UPDATE_BRAND,
    brand,
    location,
    callback
  };
};




export const addBrandSuccessFavorite = (brandFavoriteResponse: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_FAVORITE,
    brandFavoriteResponse,
  };
};

export const updateBrands = (brands: actionsInterfaces.IBrand[], callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateBrandsAction => {
  return {
    type: actionsTypes.UPDATE_BRANDS,
    brands,
    callback
  };
};

export const updateBrandsFields = (updateInfo:actionsInterfaces.UpdateInfo, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateBrandsFieldsAction => {
  return {
    type: actionsTypes.UPDATE_BRANDS_FIELDS,
    updateInfo,
    callback
  };
};

export const fetchCounterBrands = (filter?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER_BRANDS,
    filter,
    callback
  };
};

export const setCounterBrands = (counterBrands: actionsInterfaces.IBrand): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER_BRANDS,
    counterBrands,
  };
};


export const fetchBrandName = (query:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchBrandName => {
  return {
    type: actionsTypes.GET_BRAND_NAME,
    query,
    callback
  };
};


export const setBrandName = (brandNameResponse:any, callback?: (result: any, error: any) => void): actionsInterfaces.ISetBrandName => {
  return {
    type: actionsTypes.SET_BRAND_NAME,
    brandNameResponse
  };
};

export const addUpdateBrand = (brandInformation:actionsInterfaces.IAddEditBrand, snackbarText?: string, callback?: (result: any, error: any) => void): actionsInterfaces.IAddUpdateBrandAction => {
  return {
    type: actionsTypes.ADD_UPDATE_BRAND,
    brandInformation,
    snackbarText,
    callback
  };
};


export const deleteBrand = (brand: actionsInterfaces.IDeleteBrand,  callback?: (result: any, error: any) => void): actionsInterfaces.IDeleteBrandAction => {
  return {
    type: actionsTypes.DELETE_BRAND,    
    brand,
    callback
  };
};


export const deleteBrandRequest = (): actionsInterfaces.IDeleteBrandRequest => {
  return {
    type: actionsTypes.DELETE_BRAND_REQUEST
  };
};

export const deleteBrandSuccess = (): actionsInterfaces.IDeleteBrandSuccess => {
  return {
    type: actionsTypes.DELETE_BRAND_SUCCESS
  };
};


export const setAddUpdateBrand = (addUpdateResponse:actionsInterfaces.IBrand | undefined, callback?: (result: any, error: any) => void): actionsInterfaces.ISetAddUpdateBrand => {
  return {
    type: actionsTypes.SET_ADD_UPDATE_BRAND,
    addUpdateResponse
  };
};

export const setAddUpdateSnackBar = ( snackbar?: any, callback?: (result: any, error: any) => void): actionsInterfaces.ISetAddUpdateBrandSnackBar => {
  return {
    type: actionsTypes.SET_ADD_UPDATE_BRAND_SNACKBAR,
    snackbar
  };
};

export const moveFile = (backUpInformation:actionsInterfaces.IBackUp, callback?: (result: any, error: any) => void): actionsInterfaces.IMoveFileAction => {
  return {
    type: actionsTypes.BACKUP_MOVE_FILE,
    backUpInformation,
    callback
  };
};

export const setMovefileResponse = (moveFileResponse: any, callback?: (result: any, error: any) => void): actionsInterfaces.ISetMoveFileResponse => {
  return {
    type: actionsTypes.SET_MOVE_FILE_RESPONSE,
    moveFileResponse
  };
};

export const fetchYears = (oem?:string, userdata?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchYearsAction => {
  return {
    type: actionsTypes.FETCH_YEARS,
    oem,
    userdata,
    callback
  };
};

export const fetchMakes = (year: string, useremail?: string, userRole?: IUserType, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchMakesAction => {
  return {
    type: actionsTypes.FETCH_MAKES,
    year,
    useremail,
    userRole,
    callback
  };
};

export const fetchModels = (year: string, make: string, oem?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchModelsAction => {
  return {
    type: actionsTypes.FETCH_MODELS,
    year,
    make,
    oem,
    callback
  };
};

export const fetchTrims = (year: string, make: string, model: string, oem?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchTrimsAction => {
  return {
    type: actionsTypes.FETCH_TRIMS,
    year,
    make,
    model,
    oem,
    callback
  };
};

export const fetchStyles = (year: string, make: string, model: string, trim:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchStylesAction => {
  return {
    type: actionsTypes.FETCH_STYLES,
    year,
    make,
    model,
    trim,
    callback
  };
};

export const fetchVehicles = (year: string, make: string, model: string, trim:string, imgtype:string, oem?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchVehiclesAction => {
  return {
    type: actionsTypes.FETCH_VEHICLES,
    year,
    make,
    model,
    trim,
    imgtype,
    oem,
    callback
  };
};

export const setVehicle = (vehicle: actionsInterfaces.IBrandVehicle): actionsInterfaces.ISetVehicleAction => {
  return {
    type: actionsTypes.SET_VEHICLE,
    vehicle:vehicle
  };
};

export const fetchDataStyles = (year: string, make: string, model: string, trim:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDataStylesAction => {
  return {
    type: actionsTypes.FETCH_DATA_STYLES,
    year,
    make,
    model,
    trim,
    callback
  };
};


export const fetchData = (style: string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDataAction => {
  return {
    type: actionsTypes.FETCH_DATA,
    style,
    callback
  };
};


export const setData = (data: actionsInterfaces.IBrandChromeData): actionsInterfaces.ISetDataAction => {
  return {
    type: actionsTypes.SET_BRAND,
    data: data
  };
};